module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-table', {
    staticClass: "raceTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "is-horizontal-resize": "",
      "columns": _vm.columns,
      "table-data": _vm.tableData,
      "show-vertical-border": true,
      "title-bg-color": '#7ef8fc',
      "title-row-height": 30,
      "border": 1,
      "row-hover-color": "#eee",
      "row-click": _vm.raceDetail
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "btn btn--primary",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.deleteLocationData
    }
  }, [_vm._v("Delete Location Data")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6129b4a7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Race/RaceTableList.vue
// module id = 1689
// module chunks = 1